import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from 'src/app/services/user.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-configuracoes',
  templateUrl: './configuracoes.component.html',
  styleUrls: ['./configuracoes.component.css']
})
export class ConfiguracoesComponent implements OnInit {
  @ViewChild('input1') input1!: ElementRef;
  @ViewChild('input2') input2!: ElementRef;

  isOK = false;

  frmHeader!: SplashData;
  headerLoading = false;
  header!: string;

  frmFooter!: SplashData;
  footerLoading = false;
  footer!: string;

  cor!: string;
  corLoading = false;
  frmCorLoading = false;

  constructor(public userService: UserService, private router: Router) { }

  ngOnInit(): void {
    this.frmHeader = {
      loading: false,
      image: '',
    };

    this.frmFooter = {
      loading: false,
      image: '',
    };

    if (this.userService.checarPermissao('23')[0]) {
      this.isOK = true;
    } else {
      return;
    }

    this.fetchHeader();
    this.fetchFooter();
    this.fetchCor();
  }

  handleUpload(event, from: Number) {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        let re = /(?:\.([^.]+))?$/;
        let ext = re.exec(file.name)![1];
        if (from == 0) {
          this.frmHeader.image = ext + '|' + reader.result as string;
        } else {
          this.frmFooter.image = ext + '|' + reader.result as string;
        }
      };
    } else {
      if (from == 0) {
        this.frmHeader.image = '';
      } else {
        this.frmFooter.image = '';
      }
    }
  }

  fetchHeader() {
    this.headerLoading = true;
    this.userService.header().subscribe(
      (res: any) => {
        this.header = res.data;
      },
      (err: any) => {
        switch (err.status) {
          case 400:
            Swal.fire({
              title: 'Erro',
              text: String(err.error.message),
              icon: 'error',
              heightAuto: false,
              allowOutsideClick: false,
              focusConfirm: false,
              customClass: {
                confirmButton: 'btn-swal'
              },
            });
            break;
          case 401:
            localStorage.removeItem('botway');
            this.router.navigate(['/login']);
            break;
          case 422:
            let txt = '';
            Object.values(err.error.errors).forEach((value: any, index) => {
              for (let i = 0; i < Array(value).length; i++) {
                txt = txt + '[' + index + '][' + i + ']-> ' + value[i] + '<BR>';
              }
            });
            Swal.fire({
              title: 'Erro',
              html: txt,
              icon: 'error',
              heightAuto: false,
              allowOutsideClick: false,
              focusConfirm: false,
              customClass: {
                confirmButton: 'btn-swal'
              },
            });
            break;
        }
        this.headerLoading = false
      },
      () => (this.headerLoading = false)
    )
  }

  fetchFooter() {
    this.footerLoading = true;
    this.userService.footer().subscribe(
      (res: any) => {
        this.footer = res.data;
      },
      (err: any) => {
        switch (err.status) {
          case 400:
            Swal.fire({
              title: 'Erro',
              text: String(err.error.message),
              icon: 'error',
              heightAuto: false,
              allowOutsideClick: false,
              focusConfirm: false,
              customClass: {
                confirmButton: 'btn-swal'
              },
            });
            break;
          case 401:
            localStorage.removeItem('botway');
            this.router.navigate(['/login']);
            break;
          case 422:
            let txt = '';
            Object.values(err.error.errors).forEach((value: any, index) => {
              for (let i = 0; i < Array(value).length; i++) {
                txt = txt + '[' + index + '][' + i + ']-> ' + value[i] + '<BR>';
              }
            });
            Swal.fire({
              title: 'Erro',
              html: txt,
              icon: 'error',
              heightAuto: false,
              allowOutsideClick: false,
              focusConfirm: false,
              customClass: {
                confirmButton: 'btn-swal'
              },
            });
            break;
        }
        this.footerLoading = false
      },
      () => (this.footerLoading = false)
    )
  }

  fetchCor() {
    this.corLoading = true;
    this.userService.cor().subscribe(
      (res: any) => {
        this.cor = res.data;
      },
      (err: any) => {
        switch (err.status) {
          case 400:
            Swal.fire({
              title: 'Erro',
              text: String(err.error.message),
              icon: 'error',
              heightAuto: false,
              allowOutsideClick: false,
              focusConfirm: false,
              customClass: {
                confirmButton: 'btn-swal'
              },
            });
            break;
          case 401:
            localStorage.removeItem('botway');
            this.router.navigate(['/login']);
            break;
          case 422:
            let txt = '';
            Object.values(err.error.errors).forEach((value: any, index) => {
              for (let i = 0; i < Array(value).length; i++) {
                txt = txt + '[' + index + '][' + i + ']-> ' + value[i] + '<BR>';
              }
            });
            Swal.fire({
              title: 'Erro',
              html: txt,
              icon: 'error',
              heightAuto: false,
              allowOutsideClick: false,
              focusConfirm: false,
              customClass: {
                confirmButton: 'btn-swal'
              },
            });
            break;
        }
        this.corLoading = false
      },
      () => (this.corLoading = false)
    )
  }

  enviarImagem(from: Number) {
    if (from == 0) {
      if (this.frmHeader.image.length == 0) {
        Swal.fire({
          title: 'Erro',
          html: 'Nenhuma imagem selecionada.',
          icon: 'error',
          heightAuto: false,
          allowOutsideClick: false,
          focusConfirm: false,
          customClass: {
            confirmButton: 'btn-swal'
          },
        });
        return
      }
      this.frmHeader.loading = true;
      this.userService
        .atualizarHeader(this.frmHeader)
        .subscribe(
          (res) => {
            this.fetchHeader();
            this.input1.nativeElement.value = '';
            Swal.fire({
              title: 'Sucesso',
              text: 'Header Atualizado',
              icon: 'success',
              heightAuto: false,
              allowOutsideClick: false,
              focusConfirm: false,
              customClass: {
                confirmButton: 'btn-swal'
              },
            });
          },
          (err) => {
            switch (err.status) {
              case 400:
                Swal.fire({
                  title: 'Erro',
                  text: String(err.error.message),
                  icon: 'error',
                  heightAuto: false,
                  allowOutsideClick: false,
                  focusConfirm: false,
                  customClass: {
                    confirmButton: 'btn-swal'
                  },
                });
                break;
              case 401:
                localStorage.removeItem('botway');
                this.router.navigate(['/login']);
                break;
              case 422:
                let txt = '';
                Object.values(err.error.errors).forEach((value: any, index) => {
                  for (let i = 0; i < Array(value).length; i++) {
                    txt = txt + '[' + index + '][' + i + ']-> ' + value[i] + '<BR>';
                  }
                });
                Swal.fire({
                  title: 'Erro',
                  html: txt,
                  icon: 'error',
                  heightAuto: false,
                  allowOutsideClick: false,
                  focusConfirm: false,
                  customClass: {
                    confirmButton: 'btn-swal'
                  },
                });
                break;
            }
            this.frmHeader.loading = false
          },
          () => (this.frmHeader.loading = false)
        );
    } else {
      if (this.frmFooter.image.length == 0) {
        Swal.fire({
          title: 'Erro',
          html: 'Nenhuma imagem selecionada.',
          icon: 'error',
          heightAuto: false,
          allowOutsideClick: false,
          focusConfirm: false,
          customClass: {
            confirmButton: 'btn-swal'
          },
        });
        return
      }
      this.frmFooter.loading = true;
      this.userService
        .atualizarFooter(this.frmFooter)
        .subscribe(
          (res) => {
            this.fetchFooter();
            this.input2.nativeElement.value = '';
            Swal.fire({
              title: 'Sucesso',
              text: 'Footer Atualizado',
              icon: 'success',
              heightAuto: false,
              allowOutsideClick: false,
              focusConfirm: false,
              customClass: {
                confirmButton: 'btn-swal'
              },
            });
          },
          (err) => {
            switch (err.status) {
              case 400:
                Swal.fire({
                  title: 'Erro',
                  text: String(err.error.message),
                  icon: 'error',
                  heightAuto: false,
                  allowOutsideClick: false,
                  focusConfirm: false,
                  customClass: {
                    confirmButton: 'btn-swal'
                  },
                });
                break;
              case 401:
                localStorage.removeItem('botway');
                this.router.navigate(['/login']);
                break;
              case 422:
                let txt = '';
                Object.values(err.error.errors).forEach((value: any, index) => {
                  for (let i = 0; i < Array(value).length; i++) {
                    txt = txt + '[' + index + '][' + i + ']-> ' + value[i] + '<BR>';
                  }
                });
                Swal.fire({
                  title: 'Erro',
                  html: txt,
                  icon: 'error',
                  heightAuto: false,
                  allowOutsideClick: false,
                  focusConfirm: false,
                  customClass: {
                    confirmButton: 'btn-swal'
                  },
                });
                break;
            }
            this.frmFooter.loading = false
          },
          () => (this.frmFooter.loading = false)
        );
    }
  }

  atualizarCor() {
    this.frmCorLoading = true;
    this.userService
      .atualizarCor(this.cor)
      .subscribe(
        (res) => {
          Swal.fire({
            title: 'Sucesso',
            text: 'Cor Primária Atualizada',
            icon: 'success',
            heightAuto: false,
            allowOutsideClick: false,
            focusConfirm: false,
            customClass: {
              confirmButton: 'btn-swal'
            },
          });
        },
        (err) => {
          switch (err.status) {
            case 400:
              Swal.fire({
                title: 'Erro',
                text: String(err.error.message),
                icon: 'error',
                heightAuto: false,
                allowOutsideClick: false,
                focusConfirm: false,
                customClass: {
                  confirmButton: 'btn-swal'
                },
              });
              break;
            case 401:
              localStorage.removeItem('botway');
              this.router.navigate(['/login']);
              break;
            case 422:
              let txt = '';
              Object.values(err.error.errors).forEach((value: any, index) => {
                for (let i = 0; i < Array(value).length; i++) {
                  txt = txt + '[' + index + '][' + i + ']-> ' + value[i] + '<BR>';
                }
              });
              Swal.fire({
                title: 'Erro',
                html: txt,
                icon: 'error',
                heightAuto: false,
                allowOutsideClick: false,
                focusConfirm: false,
                customClass: {
                  confirmButton: 'btn-swal'
                },
              });
              break;
          }
          this.frmCorLoading = false
        },
        () => (this.frmCorLoading = false)
      );
  }
}

export interface SplashData {
  loading: boolean;
  image: string;
}
